module.exports = __webpack_public_path__ + "assets/nhs_england.cc1396a676c9f4e701a6fa5b5ac738ac.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/home/nhs_england.png
 ** module id = 346
 ** module chunks = 0
 **/